<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xv"></a>ELEVEN MORE<br/>AMERICAN WOMEN POETS<br/>IN THE 21ST CENTURY<a id="page_xvi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?feccbca8